import express, { Router } from 'express';

import * as fileValidation from '@/modules/project/files/files.validation';
import * as fileController from '@/modules/project/files/files.controller';

import { validateMiddleware } from '@/shared/utils/middlewares';
import userAuthAndCheckPermissions from '@/modules/auth/auth.user.middleware';
import { setAuditFields } from '@/shared/middleware/setAuditFields';
import { AuditMode } from '@/shared/constants/enum.constant';
import { MODULE_LIST } from '@/shared/constants/module.constant';
import { ACTIONS } from '@/shared/constants';

const router: Router = express.Router({ mergeParams: true });

router
  .route('/')
  .get(
    userAuthAndCheckPermissions(MODULE_LIST.PROJECT, ACTIONS.READ),
    validateMiddleware(fileValidation.getFiles),
    fileController.getFiles,
  )
  .post(
    userAuthAndCheckPermissions(MODULE_LIST.PROJECT, ACTIONS.CREATE),
    validateMiddleware(fileValidation.createFile()),
    setAuditFields({ mode: AuditMode.CREATE }),
    fileController.createFile,
  );

router
  .route('/:id')
  .get(
    userAuthAndCheckPermissions(MODULE_LIST.PROJECT, ACTIONS.READ),
    validateMiddleware(fileValidation.getFileById),
    fileController.getFileById,
  )
  .patch(
    userAuthAndCheckPermissions(MODULE_LIST.PROJECT, ACTIONS.UPDATE),
    validateMiddleware(fileValidation.updateFile()),
    setAuditFields({ mode: AuditMode.UPDATE }),
    fileController.updateFile,
  )
  .delete(
    userAuthAndCheckPermissions(MODULE_LIST.PROJECT, ACTIONS.DELETE),
    validateMiddleware(fileValidation.deleteFileById),
    fileController.deleteFileById,
  );

export default router;